import api from '../api'

export default {
    namespaced: true,
    state: {
        escrowSupportsList: {
            beanList: [],
            total: 0
        }
    },
    mutations: {
        setStateEscrowSupportsList(state,info){
            state.escrowSupportsList = info
        }
    },
    actions: {
        getEscrowSupportsList({commit},params) {
            return api.post('/escrowSupports/list','支付切换 - 列表',params).then(res=>{
                commit('setStateEscrowSupportsList',res.data)
            })
        },
        updateStatus(store,params){
            return api.post('/escrowSupports/changeStatus','支付切换 - 修改状态',params)
        }
    }
}